import React, { memo, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { PrivilegeContext } from '../context/PrivilegesContext'
import { Block } from '@/components/crRender'
import Sidebar from '@/templates/sidebar'
import { IsListNotEmpty } from '@/utils.js'
import Navbar from '@/templates/navbar'

const Layout = ({ children }) => {
    const { i18n } = useTranslation()
    const { authorizedPages } = useContext(PrivilegeContext)
    return (
        <div className={`wrapper ${i18n.language}`}>
            <Navbar />
            <div id="content" className="container-fluid">
                <Sidebar />
                <Block isRender={IsListNotEmpty(authorizedPages)} className={"screen-container"}>
                    {children}
                </Block>
            </div>
        </div>
    )
}

export default memo(Layout)